/**
 * nestedCheckbox
 * for indeterminate(nested) checkbox that would be in the filter
 */
export const nestedCheckbox = (function () {
  'use strict';

  var init = function () {
    var cntrClass = "nested-checkbox__container--base";

    var startClass = "." + cntrClass;
    var nestBase = document.querySelectorAll(startClass);


    for (var i = 0; i < nestBase.length; i ++) {
      initNestedCheckBox(nestBase[i]);
    }
  };


  /**
   * initNestedCheckBox
   * assign nested checkbox handler to all checkbox included in nested
   * nested checkbox
   * @param {*} root
   */
  var initNestedCheckBox = function (root) {
    var checkBoxes = root.querySelectorAll("input[type=checkbox]");

    var i;

    // loop through all checkbox inside nested checkbox and assign event handler
    for (i=0; i < checkBoxes.length; i ++) {
      checkBoxes[i].onchange = handleNestedCheck;
    }
  };


  /**
   * handleNestedCheck
   * event handler for nested checkbox
   * @param {*} e
   */
  var handleNestedCheck = function (e) {

    var self = e.currentTarget;
    // var container = self.parentElement.parentElement;
    var container = _findAncestor(self, "nested-checkbox__container");
    var checkBoxes = container.querySelectorAll("label > input[type=checkbox]");

    for (var i = 0; i < checkBoxes.length; i++) {
      setCheckBoxState(checkBoxes[i], self.checked, false);
    }

    checkStates(container, self.checked);
  };


  /**
   * sets checkbox state
   * @param {*} el
   * @param {*} checked
   * @param {*} indeterminate
   */
  var setCheckBoxState = function (el, checked, indeterminate) {
    el.checked = checked;
    el.indeterminate = indeterminate;
  };


  /**
   * trickle up to parent to change the parent state
   * @param {*} el
   * @param {*} checked
   */
  var checkStates = function (el, checked) {

    if (el.classList.contains("nested-checkbox__container--base")) {
      return;
    }

    var allSibling = true;
    var upperLi = _findAncestor(el, "nested-checkbox__container");
    var upperCheck = upperLi.children[0].children[0];

    allSibling = checkSiblingStates(el);
    // if all sibling is checked and current checkbox is checked;
    if (allSibling && checked) {
      setCheckBoxState(upperCheck, checked, false);
      checkStates(upperLi, checked);
    }
    else if (allSibling && !checked) {
      setCheckBoxState(upperCheck, checked, false);
      checkStates(upperLi, checked);
    }
    // else, set the parent to have indeterminate state
    else {
      setCheckBoxState(upperCheck, checked, true);
      checkStates(upperLi, checked);
    }

  };


  /**
   * function that will get the next series of checkboxes
   * only get the next immediate level of checkboxes
   * @param {*} container
   */
  var checkSiblingStates = function (container) {
    var ulParent = container.parentElement;

    var siblings = ulParent.children;
    var cb;

    for (var i=0; i < siblings.length; i ++) {
      cb = siblings[i].children[0].children[0];

      if (!cb.checked) {
        return false;
      }
    }

    return true;

  };


  /**
   * _findAncestor
   * find ancestor of an element that has a given class cls
   * @param {*} el
   * @param {*} cls
   */
  var _findAncestor = function (el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
  };


  return {
    init: init
  };
});
